<template>
  <div>
    <el-container style="flex-direction: column;">
      <!-- <MachMonitor></MachMonitor> -->
      <NJNav></NJNav>
      <div class="charts-box">
        <div class="tab-box">
          <div class="times">
          <!-- <p>{{ cityName }}购机补贴机具购买用户作业排行榜</p> -->
          <p>农机补贴用户作业排行榜</p>
          <p style="right: 0;">统计时间：截止到{{ getNowFormatDates() }}</p>
          <!-- <p>
            统计时间：{{ getFirstDayOfYear(new Date()) }}至{{
              getNowFormatDates()
            }}
          </p> -->
        </div>
          <el-table :data="rankList">
            <el-table-column prop="id" label="序号" width="80" type="index">
              <template slot-scope="scope">
                <span
                  :class="scope.$index + addIndex > 3 ? 'rankNumber' : 'rankNumbers'"
                  >{{ scope.$index + addIndex }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="机主姓名"
              :show-overflow-tooltip="true"
              popper-class="tips"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="provName"
              label="作业地区"
              :show-overflow-tooltip="true"
              popper-class="tips"
            >
              <template slot-scope="scope">
                <div>
                  {{
                    workrankName == 0
                      ? scope.row.provName
                      : workrankName == 1
                      ? scope.row.cityName
                      : scope.row.countyName
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="njName"
              label="农机名称"
              :show-overflow-tooltip="true"
              popper-class="tips"
            >
            </el-table-column>
            <el-table-column
              prop="factoryName"
              label="生产企业"
              :show-overflow-tooltip="true"
              popper-class="tips"
              min-width="138"
            >
            </el-table-column>
            <el-table-column
              prop="factoryCode"
              label="出厂编号"
              :show-overflow-tooltip="true"
              popper-class="tips"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="imei"
              label="监控编号"
              :show-overflow-tooltip="true"
              popper-class="tips"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="acreage"
              label="运行面积"
              :show-overflow-tooltip="true"
              popper-class="tips"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.acreage !== ''">
                  {{ scope.row.acreage + "亩" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column width="100" prop="address" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="turnDetails(scope.row)"
                  type="text"
                  size="small"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="nodata"
            style="text-align: center;line-height: 70px;font-size: 44px;color:#999;width:100%;height: 600px;line-height: 600px"
          >
            暂无数据
          </div>
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="checkcurrentPage"
              layout="total, prev, pager, next, jumper"
              :total="total"
              v-if="rankList && rankList[0]"
            >
            </el-pagination>
          </div>
          <div v-if="isloading" class="">
            <div class="el-loading-spinner">
              <i class="el-icon-loading"></i>
              <p class="el-loading-text">拼命加载中</p>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import "echarts/map/js/china.js";
import Api from "../../Serves/net-api.js";
import Http from "../../Serves/net-http.js";
// import MachMonitor from "./MachMonitor.vue";
import NJNav from '../Index/view/NJNav'

export default {
  name: "Monitor",
  components: { NJNav },
  data() {
    return {
      cityName:
        this.$store.state.areaName === "全国"
          ? this.$store.state.areaName
          : this.$store.state.areaName,
      rankList: [],
      currentPage: 1,
      isloading: false,
      checkcurrentPage: 11,
      workrankName: "",
      nodata: false,
      addIndex: 1
    };
  },
  mounted() {
    sessionStorage.removeItem('manageParams1')
    if (this.$store.state.toolWorkRankData.length !== 0) {
      var data = this.$store.state.toolWorkRankData
      this.currentPage = data.currentPage
      this.checkcurrentPage = data.checkcurrentPage
      this.getData()
    } else {
      this.getData()
    }
  },
  methods: {
    getData() {
      var parmse = {
        currentPage: this.currentPage,
        pageSize: this.checkcurrentPage
      };
      var url = Http.test + "/ranking/findRankingList";
      this.isloading = true;
      Api.doPost(url, parmse, false, res => {
        this.isloading = false;
        if (res.result.dataSource.length !== 0) {
          this.workrankName = res.result.dataSource[0].currentOrganLevel;
          this.rankList = res.result.dataSource[0].rankingList;
          this.total = res.result.totalRow;
          if (this.rankList.length == 0) {
            this.nodata = true;
          } else {
            this.nodata = false;
          }
        }
      });
    },
    handleSizeChange(val) {
      this.checkcurrentPage = val;
      this.currentPage = 1;
      this.addIndex = 1;
      this.getData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.addIndex = (this.currentPage - 1) * this.checkcurrentPage + 1;
      this.getData();
    },
    turnDetails(row) {
      var data = {
        currentPage: this.currentPage,
        checkcurrentPage: this.checkcurrentPage
      }
      this.$store.commit('toolWorkRankData', data);
      this.$router.push({
        name: "DiscountDetails",
        query: {
          imei: row.imei,
          source: row.source,
          sourceId: row.sourceId
          // njType: row.njType
        }
      });
    },
    timeFormat(date) {
      if (!date || typeof date === "string") {
        this.error("参数异常，请检查...");
      }
      var y = date.getFullYear(); // 年
      // this.yearValue = y
      var m = date.getMonth() + 1; // 月
      var d = date.getDate(); // 日
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 1 && d <= 9) {
        d = "0" + d;
      }
      // return y + "-" + m + "-" + d;
      return y + "年" + m + "月" + d + "日";
    },
    // 获取本年第一个月
    getFirstDayOfYear(date) {
      date.setDate(1);
      date.setMonth(0);
      return this.timeFormat(date);
    },
    // 获取当前日期
    getNowFormatDates() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // var currentdate = year + seperator1 + month + seperator1 + strDate;
      var currentdate = year + '年' + month + '月' + strDate + '日'
      // var currentdate = month + "月" + strDate + "日";
      return currentdate;
    }
    // jumPage() {
    //   // 跳转到作业统计页
    // }
  }
};
</script>
<style scoped>

.charts-box {
  width: 98%;
  height: 83vh;
  /* height: 100%; */
  background-image: url("/static/img/zuoyejindu-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  margin-left: 1%;
  margin-top: 1vh;
}
.block{
  width: 100%;
  margin-top: 1vh;
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-table {
  color: #fff;
  position: relative;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 14px;
  /*background-color: #06103b !important;*/
  /* box-shadow: 0 0 29px #06103b; */
  /* -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.3) !important; */
  /* border: 1px solid #06103b !important; */
}
.el-pager li{
	color: #fff !important;
}
.el-pager li.btn-quicknext,
.el-pager li.btn-quickprev {
  color: #fff !important;
}
p {
  color: #fff;
}
.tab-box {
  width: 98%;
  margin-left: 1%;
  overflow: hidden;
}


.work-rank-box {
  /* height:auto !important;  */
  height: 82vh; 
  overflow:visible;
  padding-top: 12px;
  width: 100%;
  background-image: url("/static/img/zuoyejindu-bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  /* padding-bottom: 20px; */
  margin-top: 1vh;
}
.rankNumber {
  height: 32px;
  line-height: 34px;
  display: inline-block;
  text-align: center;
}
.rankNumbers {
  width: 32px;
  height: 32px;
  display: inline-block;
  text-align: center;
  line-height: 32px;
  background: #263783;
  border-radius: 50%;
  font-size: 0.7vw;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/TableList/ToolWorkRank.vue